import { action, makeAutoObservable, observable } from "mobx"

import type { PagedResultDto } from "../../services/dto/pagedResultDto"
import companyService from "@services/clientManagement/companyService"
import fileService from "@services/common/fileService"

class CompanyStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any

  constructor() {
    makeAutoObservable(this)
    this.detailData = {}
    this.tableData = { items: [], totalCount: 0 }
  }

  @action
  async createOrUpdate(body: any, files?: any, deletedFiles?: any) {
    this.isLoading = true
    const result = await companyService
      .createOrUpdate(body)
      .finally(() => (this.isLoading = false))
    const { uniqueId } = result

    if (deletedFiles && deletedFiles.length) {
      await Promise.all(
        deletedFiles.map(async (guid) => {
          await fileService.delete(guid, false)
        })
      )
    }

    if (files && files.length && uniqueId) {
      const filesBody = {
        moduleName: "Company",
        uniqueId: uniqueId,
        descriptions: [...files].map((item) => item?.description),
      }

      await fileService.uploadDocumentWithModuleName(
        [...files].map((item) => item?.file),
        filesBody,
        false
      )
    }
  }

  @action
  async emptyDetail() {
    this.detailData = {
      name: "",
      isActive: true,
      isVerified: true,
      id: undefined,
    }
  }

  @action
  async delete(id: number) {
    await companyService.delete(id)
    this.tableData.items = this.tableData.items.filter((x) => x.id !== id)
  }

  @action
  async activate(id: number, isActive) {
    await companyService.activate(id, isActive)
  }

  @action
  async get(id: number) {
    this.isLoading = true
    const result = await companyService
      .get(id)
      .finally(() => (this.isLoading = false))
    this.detailData = result
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await companyService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }

  @action
  async exportExcel(params: any) {
    this.isLoading = true
    return await companyService
      .exportExcel(params)
      .finally(() => (this.isLoading = false))
  }
  @action
  public import = async (file: File) => {
    this.isLoading = true
    try {
      const result = await companyService
        .impportCompanys(file)
        .finally(() => (this.isLoading = false))

      return result
    } catch (error) {
      this.isLoading = false
      throw error
    }
  }
}

export default CompanyStore
